export const collectionPaymentBlog = 'https://www.mipaquete.com/soluciones-ecommerce/envios-pago-contraentrega';

export const whatsappUrl = 'https://api.whatsapp.com/send?phone=573164736403&text=Hola%3A%20quiero%20m%C3%A1s%20informaci%C3%B3n%20para%20hacer%20mis%20env%C3%ADos';

export const helpCenterUrl = 'https://www.mipaquete.com/centro-de-ayuda';

export const integrateStoreUrl = 'https://www.mipaquete.com/conecta-tu-tiendavirtual';
